import { createApi } from '@reduxjs/toolkit/query/react';
import { gql } from 'graphql-request';
import { baseQuery } from '@classity-edtech/ui-base';
import { SIGNEDURL } from '../store/actionTypes';
import { SignedUrl, SignedUrlInput } from './models/signedUrl';

export const signedUrl = createApi({
  reducerPath: SIGNEDURL,
  baseQuery,
  tagTypes: ['SignedUrl'],
  endpoints: builder => ({
    signedUrl: builder.query<SignedUrl, SignedUrlInput>({
      query: variables => ({
        document: gql`
          query GetSignedURL($mimeType: String, $path: String, $bucketName: String) {
            getSignedURL(mimeType: $mimeType, path: $path, bucketName: $bucketName) {
              uploadUrl
            }
          }
        `,
        variables,
      }),
      transformResponse: (response: any) => response?.getSignedURL,
    }),

    viewSignedURL: builder.query<SignedUrl, SignedUrlInput>({
      query: variables => ({
        document: gql`
          query ViewSignedURL($key: String, $bucketName: String) {
            viewSignedURL(key: $key, bucketName: $bucketName) {
              viewUrl
            }
          }
        `,
        variables,
      }),
      transformResponse: (response: any) => response?.viewSignedURL,
    }),
  }),
});

export const { useLazySignedUrlQuery, useLazyViewSignedURLQuery } = signedUrl;
